import { useRegisterSW } from "virtual:pwa-register/react"

import { Alert, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"

/** How often an open tab asks the server whether a newer build exists. */
const UPDATE_CHECK_MS = 60 * 60 * 1000

/**
 * Offers a freshly deployed build once the service worker has fetched it.
 *
 * A chat stays open for hours, so the worker is set to wait rather than
 * reload the page from under a half-typed message; this is the one place
 * that turns the waiting build into a reload the user chose.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return
      setInterval(() => void registration.update(), UPDATE_CHECK_MS)
    },
  })

  if (!needRefresh) return null

  return (
    <div className="flex-none border-b p-2">
      {/* Not `AlertAction`: that slot is absolutely positioned and the alert
          reserves a fixed strip for it, which two Russian labels overrun —
          on a phone the buttons landed on top of the wrapped title. A
          wrapping row keeps them beside the text when it fits and below it
          when it does not. */}
      <Alert className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
        <AlertTitle className="min-w-48 flex-1">
          Доступна новая версия приложения.
        </AlertTitle>
        <div className="flex flex-none gap-1.5">
          <Button
            size="sm"
            variant="outline"
            onClick={() => void updateServiceWorker(true)}
          >
            Обновить
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => setNeedRefresh(false)}
          >
            Позже
          </Button>
        </div>
      </Alert>
    </div>
  )
}
